import React, { Component } from 'react';
import Base from '../../../rebase';
import { 
  Form,
  FormGroup,
  FormControl,
  Button,
  Col,
  ControlLabel
} from 'react-bootstrap';
import PropTypes from 'prop-types';

  var AttendingEnum = {
    UNKNOWN: 1,
    ATTENDING: 2,
    NOTATTENDING: 3,
    properties: {
      1: {
        backgroundColor: "#EEE9E9", 
        text: "Please RSVP",
        showDietary: false},
      2: {
        backgroundColor: "#8fbc8f",
        text: "Attending",
        showDietary: true},
      3: {
        backgroundColor: "#CD5555", 
        text: "Not Attending",
        showDietary: false}
    }
  }

class RSVPPerson extends Component {

  constructor(props) {
    super(props);
    this.state = {
      guest: {
        attending: 1,
        dietary: "",
        givenName: "",
        lastName: ""
      }
    };
    this.attending = this.attending.bind(this);
    this.changeDietary = this.changeDietary.bind(this);
  }

  attending(attending) {
    console.log(this.state.guest.attending);
    console.log(AttendingEnum.ATTENDING);

    switch(attending) {
      case AttendingEnum.ATTENDING:
        Base.update('guests/' + this.props.guestID, 
          {data:{attending:AttendingEnum.ATTENDING}});
        break;
      case AttendingEnum.NOTATTENDING:
        Base.update('guests/' + this.props.guestID, 
          {data:{attending:AttendingEnum.NOTATTENDING}});
        break;
      case AttendingEnum.UNKNOWN:
        Base.update('guests/' + this.props.guestID, 
          {data:{attending:AttendingEnum.UNKNOWN}});
        break;
    }
  }

  changeDietary(e) {
    Base.update('guests/' + this.props.guestID,
      {data:{dietary: e.target.value}});
  }

  componentWillMount() {
    this.ref = Base.bindToState('guests/' + this.props.guestID, {
      context: this,
      state: 'guest',
      asArray: false
    })
  }

  render() {
    var guest = this.state.guest;
    var attending = this.state.guest.attending;
    return (
      <div Style={"background-color:"+AttendingEnum.properties[guest.attending].backgroundColor+"; padding:15px; border-radius:15px; margin:5px 0 5px 0;"}>
        <form>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={2}>
              {guest.givenName}
            </Col>
            <Col componentClass={ControlLabel} sm={2}>
              {guest.lastName}
            </Col>
            <div>
              <Button 
                type="button"
                onClick={() => this.attending(AttendingEnum.ATTENDING)}
              >
                Attending
              </Button>
              <Button 
                type="button"
                onClick={() => this.attending(AttendingEnum.NOTATTENDING)}
              >
                Not Attending
              </Button>
              <Button 
                type="button"
                onClick={() => this.attending(AttendingEnum.UNKNOWN)}
              >
                Not Sure
              </Button>
            </div>
          </FormGroup>
          
          {AttendingEnum.properties[attending].showDietary && <FormGroup controlId="formControlsTextarea">
              <ControlLabel>Dietary Requirements</ControlLabel>
              <FormControl 
                componentClass="textarea" 
                value={guest.dietary}
                placeholder="Please advise us of any dietary requirements"
                onChange={this.changeDietary} />
          </FormGroup>}
        </form>
      </div>
      );
  }
}

export default RSVPPerson;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/RSVP/RSVPPerson.jsx